module.exports = __webpack_public_path__ + "44b408522e76e8836a50815fb4ef84b3.fbx";